import PropTypes from 'prop-types';

export const rowContextValuesPropTypes = PropTypes.shape({
  entityId: PropTypes.string.isRequired,
  jurisdictionId: PropTypes.string.isRequired,
});
